import { useQuery } from '@tanstack/react-query';
import { makeRemoteGetDashboardChartData } from 'main/factories/usecases/dashboard/remote-get-dashboard-chart-data';
import { useParams } from 'react-router-dom';

const dashboardChartData = makeRemoteGetDashboardChartData();

export const useDashboardChartDataQuery = () => {
  const { locationId } = useParams();

  return useQuery({
    queryKey: ['dashboardChartData', locationId],
    staleTime: 5000, // Adjust as needed
    queryFn: async () => {
      return dashboardChartData.get({ locationId });
    },
  });
};
